<div class="container" fxLayout="column" fxLayoutAlign="center end">
  <span [class.active]="active && isFocused" [class.selected]="active"
        class="label">{{ item | categoryVideosLabel }}</span>
  <span class="label none">{{ item | categoryVideosLabel }}</span>
</div>
